import referralTypes from "./referralTypes";
import referralApi from "./referralApi";

const referralActions = {
    getReferralAnalytics: (branch_id, dates, resolve, reject) => async dispatch => {
        dispatch({ type: referralTypes.GET_REFERRAL_ANALYTICS_PENDING })
        await referralApi.getReferralAnalytics(branch_id, dates)
            .then((data) => {
                dispatch({ type: referralTypes.GET_REFERRAL_ANALYTICS_SUCCESS, payload: data })
                resolve && resolve()
            })
            .catch((e) => {
                dispatch({ type: referralTypes.GET_REFERRAL_ANALYTICS_ERROR })
                reject && reject(e)
            })
    },
}

export default referralActions;
